export default "__VITE_ASSET__DkIXeI1e__"